var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number !== null)?_c('span',{staticClass:"text-nowrap",class:_vm.cssClass},[_vm._v(" "+_vm._s(_vm.stringValue)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }